
import SearchBar from '@/components/common/SearchBar'
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue'
import { computed, onBeforeMount, reactive, ref, KeepAlive } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'

import { getTags, getTeacherTags } from '@/services/common'
import {
  getOfficialEnjoySongs,
  deleteOfficialEnjoySong,
  getPersonalEnjoySongs,
  deletePersonalEnjoySong,
  copyEnjoySong
} from '@/services/songs'
import { debounce } from '@/utils/common'
import { filterPermiison, PermissionMap } from '@/utils/auth'
import SelectBookModal from '../components/SelectBookModal'

export default {
  name: 'List',
  components: {
    SearchBar,
    DownOutlined,
    UpOutlined,
    SelectBookModal,
    KeepAlive
  },
  setup () {
    const tabList = filterPermiison([
      {
        key: 1,
        title: '官方歌曲'
      },
      {
        key: 2,
        title: '我的歌曲',
        permission: PermissionMap.ENJOY_SONGS_PERSONAL_LIST
      }
    ])
    const modalRef = ref()
    const router = useRouter()
    const pageData = reactive({
      firstLoading: true,
      advanced: false,
      type: 1,
      tagParams: {
        pageSize: 50,
        page: 1,
        keyword: ''
      },
      modalVisible: false
    })
    const formState = reactive({
      name: '',
      song_type: -1,
      book_section_id: [],
      song_code: '',
      py: '',
      status: 0,
      tag: []
    })
    const formOpts = reactive({
      bookOptions: [],
      bookOpts: {
        showName: '教材名称-章节目录'
      },
      defaultBookOpts: {
        showName: '教材名称-章节目录'
      }
    })

    const tableState = reactive({
      data: [],
      columns: [],
      loading: true,
      pagination: {
        current: 1,
        total: 1,
        pageSize: 10,
        showTotal: total => `共${total}条`,
        showQuickJumper: true
      }
    })

    tableState.columns = [
      {
        title: '歌曲名称',
        dataIndex: 'name',
        ellipsis: true,
        width: 200
      },
      {
        title: '歌曲识别码',
        dataIndex: 'song_code',
        width: 140
      },
      {
        title: '歌曲简拼',
        dataIndex: 'py',
        width: 100,
        ellipsis: true
      },
      {
        title: '标签',
        dataIndex: 'tags',
        width: 200,
        ellipsis: true,
        slots: { customRender: 'tags' }
      },
      {
        title: '创建时间',
        dataIndex: 'created_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '修改时间',
        dataIndex: 'updated_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        width: 230,
        slots: { customRender: 'action' }
      }
    ]

    const getList = debounce(async (params) => {
      const getEnjoySong = pageData.type === 1 ? getOfficialEnjoySongs : getPersonalEnjoySongs
      tableState.loading = true
      params = { ...queryParams.value, page: 1, ...params }
      delete params.status
      const { items, pagination } = await getEnjoySong(params)
      tableState.data = items
      tableState.loading = false
      tableState.pagination = { ...tableState.pagination, ...pagination }
    })

    const handleTableChange = (pag) => {
      tableState.pagination = pag
      getList({ page: tableState.pagination.current })
    }

    const queryParams = computed(() => {
      const params = { ...formState }
      if (params.song_type === -1) {
        delete params.song_type
      }
      if (params.song_code === '') {
        delete params.song_code
      }
      if (params.book_section_id.length === 0) {
        delete params.book_section_id
      } else if (params.book_section_id.length === 1) {
        params.book_id = params.book_section_id[0]
        delete params.book_section_id
      } else {
        params.book_id = params.book_section_id[0]
        params.book_section_id = params.book_section_id[params.book_section_id.length - 1]
      }
      for (const key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      params.per_page = tableState.pagination.pageSize
      params.page = tableState.pagination.current
      return params
    })

    const getTagsOptions = debounce(async () => {
      const params = {
        per_page: pageData.tagParams.pageSize,
        current: pageData.tagParams.page,
        keyword: pageData.tagParams.keyword
      }
      const getTagsService = pageData.type === 1 ? getTags : getTeacherTags
      formOpts.tags = (await getTagsService(params)).items.map(i => {
        i.label = i.tag
        i.value = i.tag
        return i
      })
    })

    const handleDelete = async (record) => {
      const deleteService = pageData.type === 1 ? deleteOfficialEnjoySong : deletePersonalEnjoySong
      await deleteService(record.id)
      message.success('删除成功')
      getList({ page: tableState.pagination.current })
      console.log(record)
    }

    const handleCreate = async () => {
      router.push(`/resource/enjoy-songs/create/${pageData.type}`)
    }

    const handleReset = () => {
      modalRef.value.handleReset()
      formState.status = 0
      formState.name = ''
      formState.song_type = -1
      formState.book_section_id = []
      formState.song_code = ''
      formState.py = ''
      formState.tag = []
      formOpts.bookOpts.showName = formOpts.defaultBookOpts.showName
      tableState.pagination.current = 1
      getTagsOptions()
      getList()
    }

    const handleSelectBookSection = (value) => {
      pageData.modalVisible = false
      if (value.values.length > 0) {
        formOpts.bookOpts.showName = value.labels.join('-')
        formState.book_section_id = value.values
      } else {
        formOpts.bookOpts.showName = formOpts.defaultBookOpts.showName
      }
      getList()
    }

    const handleTagSearch = v => {
      pageData.tagParams.page = 1
      pageData.tagParams.keyword = v
      getTagsOptions()
    }

    const handleTypeChange = () => {
      getList()
      getTagsOptions()
    }

    const handleCopy = async (record) => {
      const key = 'copy'
      try {
        await copyEnjoySong(record.id)
        message.loading({
          key,
          content: '正在处理'
        })
        message.success({
          key,
          content: '复制成功'
        })
      } catch (e) {
        message.error({
          key,
          content: '操作失败'
        })
      }
    }

    onBeforeMount(async () => {
      await Promise.all([
        getList(),
        getTagsOptions()
      ])
      pageData.firstLoading = false
    })

    return {
      tabList,
      modalRef,
      pageData,
      formState,
      formOpts,
      tableState,
      getList,
      PermissionMap,
      handleTableChange,
      handleDelete,
      handleReset,
      handleCreate,
      handleTagSearch,
      handleSelectBookSection,
      handleTypeChange,
      handleCopy
    }
  }
}
